import React from 'react';
import { PLAN_CALENDAR } from '@atlassian/jira-capabilities/src/constants.tsx';
import { setCapability } from '@atlassian/jira-capabilities/src/services/active-capability-tracker/index.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { createLayout } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';
import {
	advancedRoadmapsPlanPageInitialChecksResource,
	advancedRoadmapsReduxStoreStateResource,
} from '@atlassian/jira-router-resources-advanced-roadmaps-plan/src/services/index.tsx';
import { jiraSpaResources } from '@atlassian/jira-router-resources-spa-page-container/src/index.tsx';
import { arjCalendarEmbedRoute } from '@atlassian/jira-router-routes-advanced-roadmaps-embed-routes/src/arjCalendarEmbedRoute.tsx';
import { CalendarSkeleton } from '@atlassian/jira-skeletons/src/ui/calendar/CalendarSkeleton.tsx';
import { calendarEntryPoint } from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-calendar/entrypoint.tsx';

const planCalendarEmbedRouteEntry = createChromelessEntryPoint({
	main: calendarEntryPoint,
});

export const arjCalendarEmbedRouteEntry = createEntry(arjCalendarEmbedRoute, () => ({
	group: 'software',
	ufoName: 'software-advanced-roadmaps-calendar-embed',

	skeleton: () => {
		return <CalendarSkeleton />;
	},

	entryPoint() {
		setCapability(PLAN_CALENDAR);
		return planCalendarEmbedRouteEntry;
	},

	layout: createLayout({
		isChromeless: true,
	}),

	resources: [
		advancedRoadmapsPlanPageInitialChecksResource,
		advancedRoadmapsReduxStoreStateResource,
		...jiraSpaResources(),
	],

	preloadOptions: {
		earlyChunks: ['advanced-roadmaps-early-entry'],
	},

	meta: {
		capability: PLAN_CALENDAR,
	},

	forPaint: [],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-advanced-roadmaps-embed-entries/src/arjCalendarEmbedRouteEntry.tsx',
			whichExportToUse: 'arjCalendarEmbedRouteEntry',
		},

		enabled: true,
	},
}));
